import { Injectable } from '@angular/core';
import { WeakStrongPair } from '@modules/common/models/weak-strong-pair';

@Injectable({
    providedIn: 'root'
})
export class CurrentLoginRequestService {
    private currentLoginRequest!: WeakStrongPair;

    public getCurrentLoginRequest(): WeakStrongPair {
        return this.currentLoginRequest;
    }

    public setCurrentLoginRequest(loginRequest: WeakStrongPair): void {
        this.currentLoginRequest = loginRequest;
    }
}
